export enum Locale {
  EN_MY = 'en_MY',
  MS_MY = 'ms_MY',
  EN_PH = 'en_PH',
}
